export default __webpack_public_path__ + "static/maslolLogo-67e841fc062867a2f6bede706265a418.png";